(function($) {
  $(window).load(function() {

    if ($.fn.stick_in_parent) {
      //if (jQuery().Sticky) {
      $(".woocommerce-order-review").stick_in_parent({
        offset_top: 120
      });

      $(".sticky-element").stick_in_parent({
        offset_top: 120
      });

    }

  });
})(jQuery);